/**
 * Category navigation component.
 * Handling logic around the sidescrolled navigation for product categories.
 */

/**
 * The category navigation class.
 */
class CategoryNavigation {
	/**
	 * Constructs the MegaMenu object and initialises DOM elements.
	 */
	constructor() {
		this.addListeners();
	}

	/**
	 * Add event listeners.
	 *
	 * We look for all nav containers and add a scroll event listener to them.
	 */
	addListeners() {
		const navContainers = document.querySelectorAll( '.product-category-nav__list' );

		navContainers?.forEach( navContainer => {
			if ( navContainer ) {
				navContainer.addEventListener( 'scroll', event => this.checkScroll( event ) );
			}
		} );
	}

	/**
	 * Checks the scroll state of a specific nav container.
	 *
	 * @param {Event} event The scroll event.
	 */
	checkScroll( event ) {
		const navContainer = event.target;
		const isAtEnd = navContainer.scrollLeft + navContainer.clientWidth >= navContainer.scrollWidth - 15;
		navContainer.classList.toggle( 'scroll-end', isAtEnd );
	}
}

export default CategoryNavigation;
